import React from 'react';
import { Layout } from 'antd';
import { LayoutProp } from 'types/Content';
const { Content } = Layout;

export default function ContentLayout(props: LayoutProp) {
  return (
    <Layout style={{ background: '#fff', ...props.style }}>
      <Content>
        {props.children}
      </Content>
    </Layout>
  );
}
